import { makeDecorator } from './Injection';
class ModuleDecoratorFactory {
}
export const Module = makeDecorator('ZetaPush:Module', {
    expose: {},
    imports: [],
    providers: [],
    configurers: []
}, ModuleDecoratorFactory);
export const isDecoratedModule = (module) => {
    const annotations = Reflect.getMetadata('annotations', module) || [];
    return annotations.find((annotation) => annotation instanceof ModuleDecoratorFactory);
};
export const getDecoratedModule = (module) => {
    const annotations = Reflect.getMetadata('annotations', module) || [];
    return annotations.reduce((reduced, annotation) => {
        return annotation instanceof ModuleDecoratorFactory ? annotation : reduced;
    }, {
        expose: {},
        imports: [],
        providers: [],
        configurers: []
    });
};
